import React from 'react';
import { Results, ResultsHeaderColumn, ResultsHeaderRow, ResultsTable } from './SearchResults.styles';
import AccountSearchResultsList from './AccountSearchResultsList/AccountSearchResultsList';

export const SearchResults = () => {
  return (
    <Results key={'accountResults'}>
      <ResultsTable>
        <ResultsHeaderRow>
          <ResultsHeaderColumn>NAME</ResultsHeaderColumn>
          <ResultsHeaderColumn>ACCOUNT ID</ResultsHeaderColumn>
          <ResultsHeaderColumn>TYPE</ResultsHeaderColumn>
          <ResultsHeaderColumn>DATE</ResultsHeaderColumn>
        </ResultsHeaderRow>
        <AccountSearchResultsList />
      </ResultsTable>
    </Results>
  );
};
